<template>
  <div class="container">
    <div class="module-title">广告内容</div>
    <div v-for="(item, index) in adDetails" :key="index">
      <p>第{{ index + 1 }}份广告</p>
      <div class="first-part">
        <van-cell
          v-if="index === 0"
          title="门店类型"
          :value="item.dealerType === 1 ? '汽修厂' : '专卖店'"
        />
        <van-cell
          v-if="index === 0"
          title="品牌类型"
          :value="apply.productBrand | productBrand"
        />
        <van-cell v-if="index === 0" title="广告类型" value="门头招牌" />
        <van-cell
          title="材质"
          :value="item.materialQuality | materialQuality"
        />
        <div class="example-img">
          <div>版面示例</div>
          <van-image :src="item.pageExample" @click="previewImg">
            <template v-slot:error>加载失败</template>
          </van-image>
        </div>
        <div class="example-img">
          <div>效果图</div>
          <van-image :src="$imgPath + item.thumbnail" @click="previewImg">
            <template v-slot:error>加载失败</template>
          </van-image>
        </div>
      </div>
      <div class="second-part">
        <van-cell title="广告长度" :value="item.longs + '米'" />
        <van-cell title="广告长度" :value="item.height + '米'" />
        <van-cell
          title="广告内容"
          :value="item.content.trim() === '' ? '无内容' : item.content"
        />
        <van-cell
          class="scenery"
          title="实景图片"
          :value="item.realSceneImg.length === 0 ? '无上传照片' : ''"
        />
        <van-image
          v-for="(img, indexes) in item.realSceneImg"
          :key="indexes"
          width="100"
          height="100"
          :src="$imgPath + img"
          @click="previewImg"
        />
      </div>
    </div>
    <div class="opinion">
      <span>修改意见</span>
      <van-radio-group
        v-model="radio"
        direction="horizontal"
        @change="handleRadio"
      >
        <van-radio name="1">无意见</van-radio>
        <van-radio name="2">填写意见</van-radio>
      </van-radio-group>
    </div>
    <van-field
      v-if="userOpinionShow"
      v-model="userOpinion"
      rows="2"
      autosize
      type="textarea"
      maxlength="50"
      placeholder="请详细填写对效果图的反馈意见"
      show-word-limit
    />
    <van-button
      type="primary"
      @click="handlerConfirm"
      v-show="confirmStatus"
      :loading="subStatus"
      loading-text="提交中"
      >提交</van-button
    >
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      apply: {},
      adDetails: [],
      adID: "",
      userOpinion: "",
      userOpinionShow: false,
      needModify: false,
      confirmStatus: true,
      radio: "1",
      subStatus: false
    };
  },
  filters: {
    productBrand(type) {
      switch (type) {
        case 1:
          return "原动力";
        case 2:
          return "力猛";
        case 3:
          return "原动力+力猛";
        default:
          break;
      }
    },
    materialQuality(type) {
      switch (type) {
        case 1:
          return "铁架+灯布";
        case 2:
          return "彩钢板+PVC";
        case 3:
          return "铝塑板+PVC字";
        case 4:
          return "铝塑板+平面发光字";
        case 5:
          return "纯灯布";
        default:
          break;
      }
    }
  },
  created() {
    let adUrl = this.$route.path;
    let index = adUrl.lastIndexOf("/");
    adUrl = adUrl.substring(index + 1, adUrl.length);
    this.adID = Base64.decode(adUrl);
    this.getDetail();
  },
  methods: {
    //广告详情
    getDetail() {
      this.$api.adDetails(this.adID).then(res => {
        // console.log("广告详情: ", res);
        res = res.result;
        this.apply = res.apply;
        this.adDetails = res.contents;
        this.adDetails.forEach(val => {
          if (val.realSceneImg.length != 0) {
            val.realSceneImg = val.realSceneImg.split(",");
          } else {
            val.realSceneImg = [];
          }
        });
        if (this.apply.status > 4) {
          this.confirmStatus = false;
        }
      });
    },
    //同意
    handlerConfirm() {
      this.subStatus = true;
      if (this.userOpinion.trim() === "") {
        this.userOpinion = "";
      } else {
        this.needModify = true;
      }
      this.$api
        .reconfirm({
          id: this.adID,
          needModify: this.needModify,
          userOpinion: this.userOpinion
        })
        .then(res => {
          // console.log("res: ", res);
          if (res.code === 0) {
            this.subStatus = false;
            this.confirmStatus = false;
            Dialog.alert({
              title: "提示",
              message: "已确认",
              confirmButtonText: "关闭"
            }).then(() => {
              wx.closeWindow();
            });
          } else {
            this.subStatus = false;
            Dialog.alert({
              title: "提示",
              message: "提交失败,请检查",
              confirmButtonText: "关闭"
            });
          }
        });
    },
    //单选框
    handleRadio(e) {
      if (e === "2") {
        this.userOpinionShow = true;
      } else {
        this.userOpinionShow = false;
      }
    },
    //预览图片
    previewImg(e) {
      ImagePreview({
        images: [e.srcElement.src],
        closeable: true
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-bottom: 20px;

  .module-title {
    padding: 5px 0;
    background-color: #eaeaea;
  }

  .first-part {
    border-bottom: 15px solid #eaeaea;

    .example-img {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      font-size: 14px;

      div {
        flex: 1;
        text-align: left;
      }

      van-image {
        flex: 1;
      }
    }

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .second-part {
    border-bottom: 15px solid #eaeaea;

    .van-cell__title {
      text-align: left;
    }

    .van-cell__value {
      text-align: center;
    }
  }

  .opinion {
    display: flex;
    padding: 10px 16px;
    font-size: 14px;

    span {
      display: inline-block;
      flex: 1;
      text-align: left;
    }

    .van-radio-group--horizontal {
      flex: 1;
    }

    .van-radio--horizontal {
      margin-right: 0;
    }

    .van-radio--horizontal:first-child {
      margin-right: 8px;
    }
  }

  .van-field {
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.van-dialog__message {
  font-size: 20px;
}

.scenery:not(:last-child)::after {
  display: none;
}
</style>
